import { render } from "./FormErrors.vue?vue&type=template&id=a4c0de80&ts=true"
import script from "./FormErrors.vue?vue&type=script&lang=ts"
export * from "./FormErrors.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__